import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../components/Toast';
import { api } from '../lib/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Reset link sent to your email!');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <Link to="/"><span style={{ fontSize: 32 }}>🍽️</span> <span className="serif" style={{ fontSize: 22, fontWeight: 700 }}>QR Menu</span></Link>
        </div>

        {!sent ? (
          <>
            <h1 className="auth-title">Forgot Password</h1>
            <p className="auth-subtitle">Enter your email to receive a reset link</p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="you@example.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-full btn-lg" disabled={loading}>
                {loading ? 'Sending...' : '📧 Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <div style={{ fontSize: 64, marginBottom: 16 }}>📧</div>
            <h1 className="auth-title">Check Your Email!</h1>
            <p className="auth-subtitle" style={{ marginBottom: 20 }}>
              We've sent a password reset link to <strong>{email}</strong>.
              Please check your inbox and spam folder.
            </p>
            <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 12, padding: '14px 18px', marginBottom: 20, fontSize: 14, color: '#166534' }}>
              ⏱️ The reset link will expire in <strong>1 hour</strong>.
            </div>
            <button
              onClick={() => { setSent(false); setEmail(''); }}
              className="btn btn-outline w-full"
              style={{ marginBottom: 12 }}
            >
              Try a different email
            </button>
          </div>
        )}

        <p className="auth-footer mt-6"><Link to="/login">← Back to Login</Link></p>
      </div>
    </div>
  );
}